import React from "react";
import styled, { keyframes } from "styled-components";

const slideInUp = keyframes`
  0% { transform: translateY(50px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

const HeroContainer = styled.section`
  background: ${(props) => props.theme.colors.backgroundLight};
  color: ${(props) => props.theme.colors.text};
  padding: 120px 2rem 80px;
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  z-index: 2;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeroLogo = styled.img`
  max-width: 900px;
  width: 100%;
  height: auto;
  margin: 0 auto 2rem;
  display: block;
  animation: ${slideInUp} 1s ease-out 0s both;

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;

const CTAButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  animation: ${slideInUp} 1s ease-out 0.8s both;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const CTAButton = styled.button`
  background: ${(props) => props.theme.colors.primary};
  color: white;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  border-radius: 25px;
  transition: all 0.3s ease;
  box-shadow: ${(props) => props.theme.shadows.warm};
  position: relative;
  overflow: hidden;

  &:hover {
    background: ${(props) => props.theme.colors.textWarm};
    transform: translateY(-2px);
    box-shadow: ${(props) => props.theme.shadows.heavy};
  }

  @media (max-width: 768px) {
    padding: 1rem 5rem;
    width: 100%;
    max-width: 380px;
  }
`;

const SecondaryButton = styled.button`
  background: transparent;
  color: ${(props) => props.theme.colors.primary};
  border: 2px solid ${(props) => props.theme.colors.primary};
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  border-radius: 25px;
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => props.theme.colors.primary};
    color: white;
    transform: translateY(-2px);
    box-shadow: ${(props) => props.theme.shadows.medium};
  }

  @media (max-width: 768px) {
    padding: 1rem 5rem;
    width: 100%;
    max-width: 380px;
  }
`;

const Hero: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById("about");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <HeroContainer id="home" aria-label="דף הבית">
      <HeroContent>
        <HeroLogo
          src="/lee_logo_main_section.png"
          alt="לי פרוינד - פסיכולוגית חינוכית מומחית. הלוגו כולל תמונת פרופיל של לי עם שמה ותפקידה"
        />
        <CTAButtonGroup role="group" aria-label="פעולות ראשיות">
          <CTAButton onClick={scrollToContact} aria-label="לחץ כאן ליצירת קשר">צור קשר</CTAButton>
          <SecondaryButton onClick={scrollToAbout} aria-label="לחץ כאן לקריאה נוספת אודות">אודות</SecondaryButton>
        </CTAButtonGroup>
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
